// Force HMR cache invalidation: boot-diagnostics-1774474100
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Phase Z - Step 3: Re-enable i18n initialization
import './i18n/config';

// Boot diagnostic: confirms React mount started
if (import.meta.env.DEV) {
  // eslint-disable-next-line no-console
  console.log('[BOOT] React createRoot starting', { url: location.pathname, ts: Date.now() });
}

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>
);

if (import.meta.env.DEV) {
  // eslint-disable-next-line no-console
  console.log('[BOOT] React render() called', { ts: Date.now() });
}
